<template>
  <div class="row">
    <div class="col-4">
      <vs-input v-model="number" readonly class="w-100" label="Ingreso"/>
    </div>
    <div class="col-4">
      <vs-input v-model="loaded.date" readonly class="w-100" label="Fecha"/>
    </div>
    <div class="col-4">
      <vs-input v-model="loaded.expedient" readonly class="w-100" label="Expediente"/>
    </div>
    <div class="col-4">
      <vs-input v-model="loaded.sender" readonly class="w-100" label="Remitente"/>
    </div>
    <div class="col-4">
      <vs-input v-model="loaded.docType" readonly class="w-100" label="Tipo de documento"/>
    </div>
    <div class="col-4">
      <vs-input
        v-model="loaded.inputFormat"
        readonly
        class="w-100"
        label="Formato de ingreso"
      />
    </div>
    <div class="col-12">
      <b-table
        :fields="fields"
        :items="loaded.attachments"
        :empty-text="'Sin archivos'"
        caption="Adjuntos"
        caption-top
        show-empty
        striped
      >
        <template #cell(watch)="{ item }">
          <DownloadFile
            :mood="'compact'"
            v-if="item && item.name
              && item.watch"
            :path="item.watch"
            :name="item.name"
            class="pill-info-attach"
          />
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import DownloadFile from '@/febos/chile/dnt/components/DownloadFile';

export default {
  name: 'ReadOnlyMetaData',
  components: { DownloadFile },
  data() {
    return {
      loaded: {
        input: '',
        date: '',
        expedient: '',
        sender: '',
        docType: '',
        inputFormat: '',
        classification: '',
        name: '',
        address: '',
        phone: '',
        attachments: [],
      },
      fields: [
        { key: 'name', label: 'Nombre' },
        { key: 'type', label: 'Tipo' },
        { key: 'watch', label: 'Ver' }
      ]
    };
  },
  computed: {
    ...mapGetters('Dnts', ['detailsFile']),
    isMotherDocument() {
      return !!parseInt(this.detailsFile.dnt.estadoCodigoEstadoComprador, 10);
    }
  },
  methods: {
    loadData() {
      const number = `${this.detailsFile.dnt.categoria}-${this.detailsFile.dnt.numeroExt}`;
      this.number = number;
      this.loaded.input = this.detailsFile.numero;
      this.loaded.date = this.detailsFile.dnt.fechaCreacion.substring(0, 10);
      this.loaded.expedient = this.isMotherDocument
        ? number
        : this.detailsFile.dnt.despachoContactoDocumentoId;
      this.loaded.sender = this.detailsFile.dnt.compradorArea;
      this.loaded.docType = this.detailsFile.dnt.emisorCentroCostoNombre;
      this.loaded.inputFormat = this.detailsFile.dnt.transporteEmbalajeSello;
      this.loaded.attachments = this.detailsFile.adjuntos.map((attachment) => ({
        name: attachment.tipoDescripcion || attachment.adjuntoNombre,
        type: attachment.tipo,
        watch: attachment.adjuntoUrl
      })).sort(({ type: a }, { type: b }) => b.localeCompare(a));
    },
  },
  created() {
    this.loadData();
  }
};
</script>
